module.exports = __webpack_public_path__ + "static/media/logo.e697f315.png";